import * as types from "../action-types";

const initialState = {
    loading: false,
    sites: [],
    active_site: null,
    paginated_sites: {
        total: 0,
        per_page: 0,
        offset: 0,
        to: 0,
        last_page: 0,
        current_page: 0,
        from: 0,
        data: [],
    },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case types.ADD_WEBSITE.REQUEST:
        case types.GET_TABLE_WEBSITES.REQUEST:
            return {
                ...state,
                loading: true,
            };
        case types.ADD_WEBSITE.SUCCESS:
            return {
                ...state,
                loading: false,
                sites: payload?.sites,
                active_site: payload?.website
            };
        case types.GET_TABLE_WEBSITES.SUCCESS:
            return {
                ...state,
                loading: false,
                paginated_sites: payload?.sites
            };
        case types.ADD_WEBSITE.FAILURE:
        case types.GET_TABLE_WEBSITES.FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};
